import { ref, markRaw } from 'vue';
import ConfirmAction from "@/components/Dialogs/ConfirmAction.vue";

export const eventBus = {
    isOpen: ref(false),
    content: ref(null),
    childData: ref(null),
    modalSettings: ref(null),
    openModal(component, args, modelSettings) {
        eventBus.content.value = markRaw(component);
        eventBus.isOpen.value = true;

        if (args) {
            eventBus.childData.value = args;
        }

        if (modelSettings) {
            eventBus.modalSettings.value = modelSettings;
        } else {
            eventBus.modalSettings.value = {
                halfSize: false,
                fullSize: false,
            };
        }
        return eventBus;
    },
    setData(data) {
        eventBus.childData.value = data;
    },
    closeModal() {
        eventBus.isOpen.value = false;
        eventBus.content.value = null;
    },
    openConfirm(data) {
        eventBus.modalSettings.value = {
            halfSize: false,
            fullSize: false,
        };
        eventBus.content.value = markRaw(ConfirmAction);
        eventBus.isOpen.value = true;
        eventBus.childData.value = data;
        return eventBus;
    }
}
